import cn from 'clsx';
import css from './product-ui-cursor.module.css';
import type { Property } from 'csstype';
type ProductUICursorProps = {
  id?: string;
  x?: Property.InsetInlineStart | number;
  y?: Property.InsetBlockStart | number;
  className?: string;
  size?: 'base' | 'lg';
};
export function ProductUICursor({
  id,
  x,
  y,
  size = 'base',
  className,
  ...rest
}: ProductUICursorProps) {
  return <div id={id} className={cn(css.productUICursor, className, css[size])} style={{
    insetInlineStart: x,
    insetBlockStart: y
  }} {...rest} data-sentry-component="ProductUICursor" data-sentry-source-file="product-ui-cursor.tsx" />;
}

/**
 * Wraps an element and centres the cursor over the top
 * of that elements
 *
 * Useful for static ProductUI scenes that display the cursor
 * It's often required to be centred over the component
 *
 * @example
 * <ProductUICursorContainer>
 *  <ProductUIBasicListItem />
 * </ProductUICursorContainer>
 */
export function ProductUICursorContainer({
  children,
  size,
  x,
  y
}: {
  children: React.ReactNode;
  size?: ProductUICursorProps['size'];
  x?: Property.InsetInlineStart | number;
  y?: Property.InsetBlockStart | number;
}) {
  return <div className={css.productUICursorContainer} data-sentry-component="ProductUICursorContainer" data-sentry-source-file="product-ui-cursor.tsx">
            {children}
            <ProductUICursor size={size} x={x} y={y} data-sentry-element="ProductUICursor" data-sentry-source-file="product-ui-cursor.tsx" />
        </div>;
}